import React from 'react';

class CustomIntegerInput extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value || 0
    };
  }

  clamp = (raw) => {
    const { min, max } = this.props;
    const lower = min !== undefined ? min : 0;
    const parsed = parseInt(raw, 10);
    if (isNaN(parsed)) return lower;
    const bounded = Math.max(lower, parsed);
    return max !== undefined ? Math.min(max, bounded) : bounded;
  }

  handleChange = (event) => {
    this.setState({ value: event.target.value });
    if (this.props.onChange) {
      this.props.onChange(this.clamp(event.target.value));
    }
  }

  handleBlur = () => {
    this.setState({ value: this.clamp(this.state.value) });
  }

  render() {
    const { label, min,max } = this.props;
    const { value } = this.state;

    return (
      <div className='RT-TextBox'>
        <label>
            {label}
            {this.props.toolTip}
        </label>
        <div className='RT-TextBox__container'>
            <input
                className='RT-TextBox__input'
                type="number"
                value={value}
                onChange={this.handleChange}
                onBlur={this.handleBlur}
                min={min !== undefined ? min : 0}
                max={max}
            />
        </div>
      </div>
    );
  }
}

export default CustomIntegerInput;
